import Axios from 'api/client';
import { AxiosResponse } from 'axios';
import { Webhook, WebhookActivity, WebhookEvent } from 'types/domain';
import { PaginatedData } from 'types/pagination';

interface CreateWebhookRequest {
    name: string;
    url: string;
    enabled: boolean;
    events: string[];
}

const getWebhookEvents = () =>
    Axios.get<{ data: WebhookEvent[] }>(`/webhooks/events`).then(response => response.data.data);

const createWebhook = (accountId: number, data?: CreateWebhookRequest) =>
    Axios.post<CreateWebhookRequest>(`/accounts/${accountId}/webhooks`, data).then(
        response => response.data,
    );

const getWebhookById = (accountId: number, webhookId: string) =>
    Axios.get<Webhook>(`/accounts/${accountId}/webhooks/${webhookId}`).then(
        response => response.data,
    );

const getWebhooks = (accountId: number, params: { page?: number; limit?: number }) =>
    Axios.get<PaginatedData<Webhook>>(`/accounts/${accountId}/webhooks`, { params }).then(
        response => response.data,
    );

const updateWebhook = (accountId: number, webhookId: string, data?: CreateWebhookRequest) =>
    Axios.patch<CreateWebhookRequest, AxiosResponse<Webhook>>(
        `/accounts/${accountId}/webhooks/${webhookId}`,
        data,
    ).then(response => response.data);

const deleteWebhook = (accountId: number, webhookId: string) =>
    Axios.delete(`/accounts/${accountId}/webhooks/${webhookId}`).then(response => response.data);

const getWebhookActivities = (
    accountId: number,
    webhookId: string,
    params: { page?: number; limit?: number },
) =>
    Axios.get<PaginatedData<WebhookActivity>>(
        `/accounts/${accountId}/webhooks/${webhookId}/activities`,
        {
            params,
        },
    ).then(response => response.data);

export {
    getWebhookById,
    getWebhookActivities,
    getWebhookEvents,
    createWebhook,
    getWebhooks,
    updateWebhook,
    deleteWebhook,
};
export type { CreateWebhookRequest };
